(() => {
  const root = document.getElementById('ax-outlet');
  const host = root?.querySelector('[data-outlet-status]')?.parentElement;
  if (!host || document.getElementById('outlet-share-selection')) return;
  const button = document.createElement('button');
  button.type = 'button';
  button.id = 'outlet-share-selection';
  button.textContent = 'Copier le lien de cette sélection';
  const feedback = document.createElement('p');
  feedback.setAttribute('role', 'status');
  feedback.setAttribute('aria-live', 'polite');
  const fallback = document.createElement('input');
  fallback.type = 'text';
  fallback.readOnly = true;
  fallback.hidden = true;
  fallback.setAttribute('aria-label', 'Lien de votre sélection à copier');
  fallback.style.cssText = 'width:100%;max-width:100%;color:#222;background:#fff;border:1px solid #777;padding:12px';
  host.append(button);
  host.after(feedback, fallback);
  button.addEventListener('click', async () => {
    const current = new URL(location.href);
    const link = new URL('/collections/outlet', location.origin);
    const size = current.searchParams.get('pointure');
    if (/^(3[8-9]|4[0-6])$/.test(size || '')) link.searchParams.set('pointure', size);
    if (current.searchParams.get('selection') === 'all') link.searchParams.set('selection', 'all');
    link.searchParams.set('utm_source', 'customer_share');
    link.searchParams.set('utm_medium', 'referral');
    link.searchParams.set('utm_campaign', 'outlet_pointure');
    fallback.hidden = true;
    feedback.textContent = '';
    button.disabled = true;
    try {
      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(link.href);
          feedback.textContent = 'Lien copié. Vous pouvez le partager avec vos proches.';
          return;
        } catch {}
      }
      fallback.value = link.href;
      fallback.hidden = false;
      fallback.focus();
      fallback.select();
      feedback.textContent = 'Copiez ce lien pour partager votre sélection.';
    } finally {
      button.disabled = false;
    }
  });
})();
